import { FC, useEffect } from 'react';

import Background from '../../../component/background';
import s from './Register.module.scss';
import RegisterBenefitsContent from './benefits-content';
import RegisterForm from './register-form';

const toggleCaptchaBadge = (show: boolean) => {
  const badge = document.getElementsByClassName('grecaptcha-badge')[0];
  if (badge && badge instanceof HTMLElement) {
    badge.style.visibility = show ? 'visible' : 'hidden';
  }
};

const Register: FC = () => {
  useEffect(() => {
    toggleCaptchaBadge(true);
    return () => toggleCaptchaBadge(false);
  }, []);
  return (
    <Background>
      <div className={s.wrapper}>
        <RegisterBenefitsContent />
        <RegisterForm />
      </div>
    </Background>
  );
};

export default Register;
